var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuBoyaAijkSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F5B544;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.8,15.4c0.2,0.4,0.1,0.9-0.3,1.1l-8.1,4.7c-0.2,0.1-0.6,0.1-0.8,0l-8.1-4.7c-0.4-0.2-0.5-0.7-0.3-1.1 c0.2-0.4,0.7-0.5,1.1-0.3c0,0,0,0,0,0l7.7,4.4l7.7-4.4C20.1,14.9,20.6,15,20.8,15.4z M20.8,11.7c0.2,0.4,0.1,0.9-0.3,1.1l-8.1,4.7 c-0.2,0.1-0.6,0.1-0.8,0l-8.1-4.7c-0.4-0.2-0.5-0.7-0.3-1.1c0.2-0.4,0.7-0.5,1.1-0.3c0,0,0,0,0,0l7.7,4.4l7.7-4.4 C20.1,11.2,20.6,11.3,20.8,11.7z M12.4,3l8.1,4.7l0,0c0,0,0,0,0,0l-0.1,0c0.1,0.1,0.2,0.2,0.3,0.3l0,0l0,0c0,0,0,0,0,0l0-0.1 c0.1,0.1,0.1,0.2,0.1,0.4v0.1c0,0,0,0,0,0.1l0,0c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1l0,0l0,0c0,0,0,0,0,0l0-0.1 c-0.1,0.1-0.2,0.2-0.3,0.3l0,0l-8.1,4.7c-0.2,0.1-0.6,0.1-0.8,0L3.5,9.1l0,0c0,0,0,0,0,0l0.1,0C3.4,9,3.3,8.9,3.2,8.8l0,0l0,0 c0,0,0,0,0,0l0,0.1C3.1,8.6,3.1,8.4,3.1,8.2c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1l0,0l0,0c0,0,0,0,0,0l0,0.1c0.1-0.1,0.2-0.2,0.3-0.3 c0,0,0,0,0,0L11.6,3C11.8,2.9,12.2,2.9,12.4,3L12.4,3z M12,4.9L6,8.4l6,3.5l6-3.5C18,8.4,12,4.9,12,4.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBoyaAijkSelected);
export default __webpack_public_path__ + "static/media/menu_boyaAijk_selected.169ddb7a8e18fcda1ffd7c37098839d5.svg";
export { ForwardRef as ReactComponent };